import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepContent from '@material-ui/core/StepContent'
import Stepper from '@material-ui/core/Stepper'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import FlightLand from '@material-ui/icons/FlightLand'
import FinishDayForm from 'components/hiboutikForms/FinishDayForm'
import TillManagementForm from 'components/hiboutikForms/TillManagementForm'
const styles = theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: 50,
    height: 50
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit
  }
})
function getSteps() {
  return ['Vérification de la caisse', 'Clôture de la journée', 'Terminé']
}

class EndDayModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    startDate: PropTypes.string.isRequired,
    endDay: PropTypes.func.isRequired,
    transactions: PropTypes.array.isRequired
  }
  state = {
    finishDisabled: true,
    activeStep: 0,
    nextDisabled: true
  }
  handleNext = e => {
    this.setState({
      nextDisabled: true,
      activeStep: this.state.activeStep + 1,
      finishDisabled: this.state.activeStep !== 1
    })
  }
  handleBack = e => {
    this.setState({
      activeStep: this.state.activeStep - 1,
      finishDisabled: this.state.activeStep !== 1
    })
  }
  renderNextButton() {
    const { classes } = this.props
    const { activeStep } = this.state
    const steps = getSteps()
    return (
      <Grid
        style={{ marginBottom: 10 }}
        container
        direction="row"
        alignItems="flex-start"
        justify={activeStep !== 0 ? 'space-between' : 'flex-end'}>
        {activeStep !== 0 && (
          <Button
            color="secondary"
            onClick={this.handleBack}
            className={classes.button}>
            retour
          </Button>
        )}
        <Button
          color="primary"
          disabled={this.state.nextDisabled}
          onClick={this.handleNext}
          className={classes.button}>
          {activeStep === steps.length - 1 ? 'Terminer' : 'Suivant'}
        </Button>
      </Grid>
    )
  }
  getStepContent(stepIndex) {
    const { auth, startDate } = this.props
    switch (stepIndex) {
      case 0:
        return (
          <StepContent style={{ height: 'calc(100% + 16px)' }}>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center">
              <Grid item>
                <TillManagementForm
                  onClick={this.handleHiboutikFormClick}
                  hiboutikAccount={auth.hiboutikAccount}
                />
              </Grid>
              <Grid item>
                <Typography variant="caption" gutterBottom>
                  Une fois la vérification effectuée sur Hiboutik, cliquez sur
                  'Suivant'
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {this.renderNextButton()}
            </Grid>
          </StepContent>
        )
      case 1:
        return (
          <StepContent style={{ height: 'calc(100% + 16px)' }}>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center">
              <Grid item>
                <FinishDayForm
                  onClick={this.handleHiboutikFormClick}
                  hiboutikAccount={auth.hiboutikAccount}
                  dateSynth={startDate}
                />
              </Grid>
              <Grid item>
                <Typography variant="caption" gutterBottom>
                  Une fois la journée clôturé sur Hiboutik, cliquez sur
                  'Suivant'
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {this.renderNextButton()}
            </Grid>
          </StepContent>
        )
      case 2:
        return (
          <StepContent>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center">
              <Grid item>
                <Typography variant="subheading" gutterBottom>
                  Bravo ! Vous avez clôturé votre journée ! Cliquez sur
                  'Terminer'
                </Typography>
              </Grid>
            </Grid>
          </StepContent>
        )
      case 3:
        return <StepContent />
      default:
        return <StepContent />
    }
  }
  handleStartDay = () => {
    this.props.endDay()
  }
  handleHiboutikFormClick = () => {
    this.setState({ nextDisabled: false })
  }
  renderStepper() {
    const { activeStep } = this.state
    const steps = getSteps()
    return (
      <Grid item xs={12}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                {this.getStepContent(index)}
              </Step>
            )
          })}
        </Stepper>
      </Grid>
    )
  }
  render() {
    const { transactions } = this.props
    const allClosed = transactions.length === 0
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleStartDay}
        title={`Terminer la journée`}
        okText="Terminer"
        showCancel
        okDisabled={this.state.finishDisabled}
        showOk>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-around">
          <Grid
            item
            xs={12}
            container
            direction="column"
            alignItems="center"
            justify="flex-start">
            <Grid item>
              <Avatar className={this.props.classes.avatar}>
                <FlightLand color="inherit" />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="subheading" noWrap>
                {' '}
                Terminer la journée{' '}
              </Typography>
            </Grid>
          </Grid>
          {allClosed && this.renderStepper()}
          {!allClosed && (
            <Grid item>
              <Typography variant="body2" noWrap>
                Vous devez clôturer toutes les ventes en cours pour terminer la
                journée
              </Typography>
            </Grid>
          )}
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(EndDayModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/EndDayModal.js